angular.module('Itao.IndicatorMap').factory('IndicatorSetHandling', function () {
  'use strict';

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param indicatorSet
   */
  function sortIndicatorsAndLists(indicatorSet) {
    return indicatorSet.indicators
      .filter(function(indicator){
        return indicator.list === false;
      })
      .concat(indicatorSet.lists)
      .sort(function(a,b){
        return a.listIndex - b.listIndex;
      });
  }

  /**
   *
   * @param indicatorSet
   */
  function sortIndicatorsAndListsFlat(indicatorSet) {
    return sortIndicatorsAndLists(indicatorSet).reduce(function(list, indicatorOrList) {
      if(isList(indicatorOrList)) {
        return list.concat(indicatorOrList.indicators)/*.sort(function(a,b){
          return a.listIndex - b.listIndex;
        })*/;
      } else {
        return list.concat([indicatorOrList])
      }
    }, []);
  }

  return {
    sortIndicatorsAndListsFlat: sortIndicatorsAndListsFlat,
    sortIndicatorsAndLists: sortIndicatorsAndLists
  };
});
